import QuantityInput from "./QuantityInput";

export default class QuantityInputSelect extends QuantityInput {
    constructor() {
        super();

        /**
         * @type {QuantityInput}
         */
        this.quantityInput = document.querySelector('quantity-input');

        this.input = this.quantityInput.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.select = this.querySelector('select');

        this.select.addEventListener('change', this.onSelectChange.bind(this));

    }

    onSelectChange() {
        this.input.value = this.select.options[this.select.selectedIndex].value;
    }

}